import $ from "jquery";
import Swiper from "../swiper-base.js";

function initSliderType1() {
    $(".slider_type1.slider-init").each(function (index, element) {
        var slider_object = $(element);
        var slide_id = slider_object.parent().attr("id");
        var next = "#" + slide_id + " .swiper__next";
        var prev = "#" + slide_id + " .swiper__prev";
        var slidesPerView_mobile = slider_object.data("slidesperview_mobile");
        var slidesPerView_tablet = slider_object.data("slidesperview_tablet");
        var slidesPerView_desktop = slider_object.data("slidesperview_desktop");
        var space_mobile = slider_object.data("space_mobile");
        var space_desktop = slider_object.data("space_desktop");
        var slide_index = slider_object.data("slide_index");
        var slide_index_mobile = slider_object.data("slide_index_mobile");

        // Slider-type-1-specific Swiper options — change freely without affecting image_box_slider.
        new Swiper(element, {
            loop: false,
            slidesPerView: slidesPerView_mobile,
            spaceBetween: space_mobile,
            initialSlide: slide_index_mobile,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
            },
            breakpoints: {
                700: {
                    slidesPerView: slidesPerView_tablet,
                    spaceBetween: space_desktop,
                    initialSlide: slide_index_mobile,
                },
                1440: {
                    slidesPerView: slidesPerView_desktop,
                    spaceBetween: space_desktop,
                    initialSlide: slide_index,
                },
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
        });
    });
}

$(document).ready(function () {
    setTimeout(initSliderType1, 100);
});

document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("in-view");
                }
            });
        },
        { threshold: 0.4 }
    );

    document.querySelectorAll(".slider_type1_heading").forEach((el) => {
        observer.observe(el);
    });
});
